import { render } from "./NotificationsContent.vue?vue&type=template&id=70cd6678"
import script from "./NotificationsContent.vue?vue&type=script&lang=js"
export * from "./NotificationsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__